<pr-status-label
  [dense]="isDense"
  [label]="status"
  [color]="statusColourMap[status]"
 />
